import script from "./DashboardLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__